// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"b594c2964e89f3dd","993":"db6df92a411a462f"}[chunkId] + ".css";
};